module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fm-title",
    attrs: {
      "id": "Introduction"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Distinguished Professor of Political Science as well as Sociology, Dankwart A. Rüstow, of Princeton and the City University of New York, wrote in the prestigious journal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Foreign Affairs")]), _vm._v(" back in 1979:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("No nation that has maintained close relations with the United States for the last generation is so little understood by well-informed Americans as is Turkey. Even West Europeans, from their closer vantage point, are rarely better informed. In part, this lack of understanding may be due simply to limited contact. There is in the United States no sizable Turkish-American community, hence, no ready Turkish constituency in American public opinion. In western Europe, Turks are present in large numbers but as guest workers living with their families, apart and unassimilated in the more crowded parts of the cities, and eager to save enough of their wages for the ultimate return home to Turkey."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn1",
      "id": "rintfn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not much has changed in this respect in spite of Turkey’s bid for EU membership and the ensuing dangling of Turkey by “old Europe’s” leaders. When Dankwart Rüstow penned the above lines, his knowledge in this area did not derive strictly from academic research or readings. The son of sociology professor Alexander Rüstow, who was kicked out by the Nazis from his position at Berlin’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Handelshochschule")]), _vm._v(" in 1933, Dankwart Rüstow received his undergraduate education in Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the tale of individuals caught at the cross roads of history and in the line of its fire. While their native lands were discarding them, their lives were saved because an alien country was discarding a societal culture inherited from the Ottoman Empire. Turkey had recognized the need to modernize its society while Germany and Austria were regressing into Fascism. As Nazis came to power, these émigré professors and professionals who were notable in their own fields, but were mostly Jewish and were "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("opposed to Nazism, left an indelible mark on Turkey on their way to their ultimate destinations in the west and to what is now the State of Israel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No other act served republican Turkey’s founding fathers’ vision of modernizing and westernizing Turkish society more than the development of the country’s universities."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn2",
      "id": "rintfn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Without a doubt the total impact on Turkey’s higher education was much greater than the sum of the émigré professors’ individual contributions. No other policy served that country’s educational reforms more than those invitations that had been extended to Nazi-persecuted German, Austrian, and later German-speaking Czech intelligentsia. No other country had a national policy to salvage so much discarded intellectual capital from elsewhere, in order to facilitate the achievement of its own goals and objectives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This arrangement served the Nazis’ aim of making their universities, professions, and their arts "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Judenrein")]), _vm._v(" or cleansed of Jewish influence before the activation of death camps and, at the same time, benefiting the Turks. Germany also saw this “benefit” as an exploitable chit on issues of Turkey’s neutrality during wartime."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn3",
      "id": "rintfn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" Thus, the national self-serving policies of two disparate governments served humanity’s ends during the darkest years of the 20th century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As fortuitous as the timeliness of the émigrés’ arrivals had been for Turkey, so had been their voluntary, and in some cases, forced, departures. Unfortunately for all, Atatürk died in 1938 before his vision and the blueprint for its creation and implementation had been completely set down for his successors. And, by the late 1940s, the critical mass of trained Turkish cadres, essential for sustained takeoff, had finally been developed"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn4",
      "id": "rintfn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" and over three hundred émigré families moved on. It must now be noted that like Turkey, the United States, directly or indirectly, was also a major beneficiary of the Nazi-dictated exodus of intellectuals, starting about 1933. However, there were many missed cues. Information received from many sources including America’s own ambassadors was not acted upon. President Franklin Delano Roosevelt was disinterested. Bureaucratic impediments on the part of the US government were everywhere, so was widespread anti-Semitism, sexism, age discrimination, and the financial woes of America’s research and/or private universities. Yet, had Albert Einstein not fled Germany in December 1932, a month before the Nazis came to power, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Manhattan Project")]), _vm._v(" would not have been initiated when it was, the atomic bomb would not have been produced when it was, and Japan would not have surrendered when it did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hungarian-born Leo Szilard left Germany in 1933 and Enrico Fermi left Italy in 1939, both to escape persecution. The impact that these men, together with Hungarian émigrés like Edward Teller and Theodore von Karman (who anticipated Nazi persecution), made on American science "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("and technological development cannot be overstated. By contrast, Germany in 2005 was not even close to regaining the stature in the scientific world it held prior to 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Moreover, “[t]he triumphant rise of American economics after 1940 was enormously accelerated by the importation of scholars from Hitlerian Europe.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn5",
      "id": "rintfn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Likewise, Germany’s current community of expatriate Turks is overwhelmingly comprised of laborers"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn6",
      "id": "rintfn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and their families while in America Turkish expatriates are predominantly professionals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("America’s society continues to reap some of the fruits of Turkey’s efforts to modernize its system of higher education via the second or perhaps the third generation of those trained by the émigré professors. Moreover, American science, humanities, and arts have benefited even more directly from the wisdom and fortitude of successive Turkish administrations during the trying years preceding and during World War II, an unexpected and unforeseen consequence of that policy or practice. Though some of the émigré professors adapted to the host culture, learned its language, stayed on, and continued to make contributions into the 60s, others reemigrated in the 30s and 40s as soon as their contracts elapsed and other opportunities opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately after the war, the United States allowed entry to refugees from Nazism much more readily than it did in the 30s and during wartime. Hence, for differing reasons, re-emigration started at the war’s onset and peaked within a few years of the war’s end. Almost all who came to the United States continued their work, making significant contributions at America’s institutions. At least 188 persons, i.e., the professionals and their immediate families, are known to have reached America’s shores."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn7",
      "id": "rintfn7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Machtergreifung!")]), _vm._v(" The Nazi Takeover of Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The year was 1933. The date was January 30. Hitler came to power. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gesetz zur Wiederherstellung des Berufsbeamtentums")]), _vm._v(" or the Reestablishment of the Civil Service Law was passed a few weeks later. The end! The capstone had been placed over one of the world’s wonderfully productive wellsprings of science, technology, and culture. All this happened in the German-speaking part of Europe. On the whole, Europe has never recovered from Germany’s devastations. The new civil service rules were designed to enable speedy dismissal of professors with Jewish lineage and others considered politically suspect from all positions in German universities and institutes."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn8",
      "id": "rintfn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" Austria followed in Germany’s boot-steps after the March 9 1938 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Anschluss,")]), _vm._v(" the annexation of Austria by Germany although the writings on the walls were writ large long before that. Similarly, in the "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Sudetenland portion of Czechoslovakia after the September 29 1938 talks ended with the “Munich Agreement,” a “meeting of the minds” between Adolf Hitler, British Prime Minister Neville Chamberlain, French Premier Édouard Daladier, and Italian Dictator Benito Mussolini. Hidden in the Agreement’s bottom line was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Raus!")]), _vm._v(" Out with the Jews and the new Order’s non-believers from German-speaking Europe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon gone and dispersed was the “Berlin Group.” The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gesellschaft für empirische Philosophie")]), _vm._v(" or the Berlin Society for Empirical Philosophy was comprised of some of the world’s leading philosophers and scientists who gathered round Hans Reichenbach in the late 1920s. Its informal membership included the great mathematician, aerodynamicist, engineer and positivist philosopher Richard von Mises, the Prague theoretical physicist Philipp Frank, mathematicians David Hilbert, Kurt Grelling, and Walter Dubislav, mathematician-philosopher Carl Hempel, and the scientist’s scientist Albert Einstein listened on its sidelines. The Society’s members were particularly active in analyzing contemporary physics, especially the theory of relativity and the development of the frequency interpretation of probability. After the rise of Nazism, several of these great minds emigrated from Germany. Reichenbach moved to Turkey in 1933 and to the United States in 1938, Hempel to Belgium in 1934 and to the United States in 1939, but Kurt Grelling was killed in a concentration camp. The “Berlin Group” was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kaput!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The “Vienna Circle” which also started as a cooperative discussion group in 1922 and later renamed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Verein Ernst Mach,")]), _vm._v(" or the Ernst Mach Association, collapsed as well. The Circle encompassed Austria’s most prominent philosophers, scientists, and mathematicians. They were scientifically or mathematically oriented philosophers, and philosophically gifted scientists and mathematicians. Included were Richard von Mises, applied mathematician-physicist Philip Frank, logician-mathematician H. Hahn, mathematician Kurt Reidemeister, and the Circle’s magnet, ethicist Moritz Schlick who had paved the way for much that became the crux of Logical Positivism in his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Allgemeine Erkenntnislehre")]), _vm._v(" or “General Theory of Knowledge.” Others included psychologist- sociologist-economist Otto Neurath, philosopher-mathematician Rudolf Carnap who gave us "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Logical Syntax of Language,")]), _vm._v(" as well as other important works in modern logic including the foundations of mathematics, concept-formation in physics, and a logical systematization of the concepts of empirical knowledge in general.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gone was the Circle that met regularly in Vienna to investigate scientific language and scientific methodology. The Circle-spawned philosophical movement has been called variously logical positivism, logical empiricism, scientific empiricism, neopositivism, and the unity of science movement. It gave us the philosophical ideas of logical positivism, unified science, a "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("scientific world-view, epistemology, and philosophy of science, necessary propositions, the principle of verification, consistent empiricism and so on."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn9",
      "id": "rintfn9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The great philosopher of science, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Karl R. Popper,")]), _vm._v(" although he never attended the Circle’s meetings, was influential in the reception and criticism of their doctrines. In their heyday, there was a close connection between the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Berlin Group")]), _vm._v(" and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vienna Circle.")]), _vm._v(" Together they organized several congresses on epistemology and philosophy of science. Some of the Circle members attended meetings in Berlin, notably Otto Neurath and Rudolf Carnap. Interestingly, several “Gestalt” psychologists such as Wolfgang Köhler and Max Wertheimer at times attended the Berlin meetings as well. In fact, there was not just one, but several “Vienna Circles.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most striking feature of these circles was precisely their points of contact. Almost all of these circles overlapped with other neighboring circles which, in their various cultural formations—including literature, music, architecture, satire, psychoanalysis, and Zionism—pursued similarly radical goals.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Germany the way it used to be was a [cultural] oasis in the desert.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—Albert Einstein, July 1934. Letter to Alfred Kerr, Einstein Archive 50-687"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn10",
      "id": "rintfn10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dispersed were the thinkers whose works were translated in unified science—as The Vienna Circle monograph series originally edited by Otto Neurath. Fortunately, many were able to emigrate to the United States where they taught in several universities. Some went to the UK. Schlick, who remained in Austria, was killed at the University of Vienna in 1936 by a student with Nazi sympathies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Also dispersed were many of the major contributors to the arts, such as renowned composer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Paul Hindemith,")]), _vm._v(" conductor "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ernst Praetorius,")]), _vm._v(" famous theatrical producer "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carl Ebert,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rudolph Belling,")]), _vm._v(" professor of sculpture at the Fine Arts Academy in Berlin. Originally, all had sped to Turkey to escape the Nazis, as did some Austrian intellectuals just before and after the Anschluss. Among these were "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Margarete Schütte-Lihotzky,")]), _vm._v(" the first, and surely the most famous, Austrian female architect, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Andreas Tietze,")]), _vm._v(" a world-renowned Turkologist. Turkey was also a destination for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leopold Levy,")]), _vm._v(" a French Jew and academic painter, and for a number of Czech scientists and physicians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Germany! In physics alone, Germany yielded Nobel laureates the likes of Wilhelm Conrad Röntgen (1901); Philipp Lenard (1905); Ferdinand Braun (1909); Wilhelm Wien (1911); Max Laue (1914); Max Planck (1918); Johannes Stark (1919); Albert Einstein (1921); James Franck (1925); Gustav "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("Hertz (1925); and Werner Heisenberg (1932). In addition to these, there were many others including Hermann von Helmholtz and Gustav Robert Kirchhoff, names enshrined in our modern college textbooks. Germany! In the city of Göttingen were such luminaries as Enrico Fermi, Walther Boothe, Otto Hahn, Werner Heisenberg, Max von Laue, and a galaxy of other Nobel laureates and laureates-to-be. In earlier days, Göttingen used to be an intellectual feast. Göttingen’s University and its various institutes were “Nazified” soon after the start of 1933.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Post-Nazi Germany would never again claim so many Nobel-stature physicists in its midst. The same is true for Austria ("), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_2"
    }
  }, [_vm._v("Fig. 2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Emergence of Turkey as a Republic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Germany’s loss proved to be a gain for the new Republic of Turkey. German-speaking Europe’s grievous developments followed the creation of the Turkish Republic by no more than one decade, ten years after the end of Turkey’s prolonged War of Independence. The Ottoman Empire’s rule was abolished and in July 1923, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lausanne Treaty of Peace")]), _vm._v(" with Great Britain, France, Greece, Italy, Turkey, and others was signed. In mid-October, Ankara became the capital of the new Turkish State. On October 29, the Republic was proclaimed. These developments were followed in short order by radical social and economic reforms championed by modern Turkey’s founder and its first president, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kemal Atatürk.")]), _vm._v(" He was a career military officer turned revolutionary and statesman.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mustafa Kemal Atatürk was born in 1881 in the Ottoman city called Salonica. Starting with the traditional religious education, then a military high school education, he graduated from Istanbul’s War Academy in 1905. Upon graduation, he was commissioned Staff Captain. In 1915, the Dardanelles campaign was launched by Winston Churchill to aid Russia in order to draw some Turkish troops away from the Caucasus where Russia was being pushed back. In those battles, Colonel Atatürk became a national hero by winning successive victories and repelling all invaders. Promoted to general in 1916 when only 35, he went on to liberate two major provinces of eastern Turkey that year. During the next two years, he served as commander of several Ottoman armies in Palestine, Aleppo, and elsewhere. He achieved another major victory by stopping Allied advances at Aleppo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 19 1919, Atatürk landed in the Black Sea port of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Samsun")]), _vm._v(" to start the Turkish War of Independence. In defiance of the Sultan’s government, he and his “Young Turks” rallied a liberation army in Anatolia and convened the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Congress of Erzurum")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sivas")]), _vm._v(" which established the basis for "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("the new national effort under his leadership. On April 23 1920, the Grand National Assembly was inaugurated and Atatürk was elected President. Fighting on many fronts, he led Turkey’s forces to victory. Following the Turkish triumph in the two major battles at Inönü in western Turkey, the Grand National Assembly conferred on him the title of Commander-in-Chief with the rank of Marshal. At the end of August 1922, the Turkish armies won their ultimate victory. Within a few weeks, the armistice was signed. The Republic of Turkey had a social visionary at its head, a man who had plans for great changes for his country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, for its system of higher education, the Republic of Turkey inherited around three to four hundred Ottoman vintage (Islamic) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madrasas,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn11",
      "id": "rintfn11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(" (“house of knowledge” in Arabic), a fledgling state university teaching some western sciences based on the French university model and using Turkish and French professors. It also had three military academies."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn12",
      "id": "rintfn12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" As one of their first acts, the Young Turks abolished all the madrasas. That left the country three military academies and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(" as a system of higher education. To be sure, toward the end of the 19"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" century, due to the urgency of wars, the military academies were upgraded to include instruction in western science taught for the most part in French by expatriate French military officers, the empire’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("lingua franca.")]), _vm._v(" One such academy became a civil engineering school in 1909 and early in the Republican era it evolved into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Istanbul Technical University.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secularization was one of the Republic’s (and Atatürk’s) missions from the outset. This principle was later enshrined in Turkey’s constitution. A number of major reforms had to take place to meet the goals of government policies of modernization and even westernization or Europeanization throughout Turkish society. With breakneck speed, Atatürk forced a “revolution from above” on to his people. The reforms included, secular governance, abolition of the traditional headwear (the fez and the veil), the replacement of Arabic script with Roman characters, enforcement of monogamy, opening three western-mode state universities, creating an industrial (as opposed to agricultural) infrastructure, and the introduction of a civil code structured according to European standards (no caliph). ("), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_3"
    }
  }, [_vm._v("Fig. 3")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of these visions have indeed been implemented and they survive to this very day. The abolition of the head scarves, however, is being challenged on university campuses. They are worn widely on the streets of Istanbul today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though most were career military officers, the leadership of Turkey’s new government was aware that the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("madrasa")]), _vm._v("-based system of civilian higher education, which had served an empire for centuries, was woefully behind the education provided by western knowledge-seeking "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("universities. Although training of civil administrators to serve the empire was a mission for some of the madrasas, the system and its components needed to be redesigned if not replaced."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn13",
      "id": "rintfn13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Consequently, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dar-ül Fünun")]), _vm._v(" was transformed into the University of Istanbul and, as was mentioned earlier, Istanbul Technical University was created out of a former military academy."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn14",
      "id": "rintfn14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other hand, it was Atatürk himself who said that Ankara University was founded from the ground up, “for those principles that describe a modern society, science, and enlightenment. “Borrowing comments made in a different context by John Staudenmaier, SJ,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn15",
      "id": "rintfn15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" this “value-laden embrace” of modern universities by Mustafa Kemal Atatürk, Turkey’s most revered personage, initiated a “design stage” of the country’s system of higher education. Beholden to his “leadership qualities and position” the “enduring nature of government policy” was institutionalized simultaneously with the “enduring nature of cultural values.” The three universities were to be fashioned on the prevailing German university model."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn16",
      "id": "rintfn16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" However, personnel to do all this were not to be found in this new country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The passage of Germany’s “Civil Service Law” forced departure by its intellectuals having (or thought to have) Jewish heritage. Realizing that the worst was yet to come, many looked for ways of leaving their beloved "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heimat,")]), _vm._v(" or motherland. Most did not have the option of going to the States or Great Britain, given the restrictive immigration laws in place in those countries at the time. All were keenly aware of the lack of university job opportunities due to America’s emergence from economic depression and widespread anti-Semitism in university hiring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among those first fired from their jobs was Hungarian-born Frankfurt pathologist, Dr. Philipp Schwarz. He quickly fled with his family to Switzerland. Schwarz’s father-in-law was Professor Sinai Tschulok, a natural scientist, who had taken refuge in Switzerland after the 1905 Russian Revolution. He was a good friend of Albert Malche, professor of pedagogy who was called on to visit Turkey in 1932 and prepare a report on the Turkish educational reform. Malche was in touch with Tschulok. The persecution of some scientists had already begun in Germany. It seems Albert Malche saw the double opportunity and got in touch with Schwarz. The actions of this man were of tremendous importance to many of his colleagues: in March 1933, Schwarz established the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notgemeinschaft Deutscher Wissenschaftler im Ausland,")]), _vm._v(" The Emergency Assistance Organization for German Scientists, to help Jewish and other persecuted German scholars secure employment in countries prepared to receive such refugees."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn17",
      "id": "rintfn17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" ("), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_4"
    }
  }, [_vm._v("Fig. 4")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Predisposed to German science and culture because of longstanding ties between the two countries and recognizing the opportunity that presented itself, Turkey invited Philipp Schwarz"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn18",
      "id": "rintfn18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" to Ankara for meetings "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("with representatives of the government. Schwarz had brought with him a list of names from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notgemeinschaft,")]), _vm._v(" and provided these names to his Turkish counterparts."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn19",
      "id": "rintfn19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Their mission was to select individuals with the highest academic credentials in disciplines and professions most needed in Turkey. Minister of education "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Resit Galip")]), _vm._v(" arrived with a complete list of professorships at the University of Istanbul."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn20",
      "id": "rintfn20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" In his memoirs, Fritz Neumark, one of the émigré professors who went to Turkey, describes the day when Schwarz sat down with his Turkish counterparts as “the day of the German-Turk miracle.” In nine hours of negotiations, it was possible to put together a complete list of names for the professorships of the new Istanbul University—and all were members of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notgemeinschaft!")]), _vm._v(" At the end of the day, an overjoyed Schwarz was able to telegraph Zurich from Ankara: “Not three, but thirty!” However, “it was clear from the beginning that the German professors were meant to stay only until their Turkish pupils, i.e., their assistants and lecturers, could take over these positions. Therefore, five-year contracts became the rule. Courses were to be taught as soon as possible in Turkish, using textbooks which had been translated into Turkish as well.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn21",
      "id": "rintfn21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the 1933 appointments were negotiated directly by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notgemeinschaft")]), _vm._v(" with the Turkish government they later all had to be preapproved by the Nazi government, even though that very government forced the dismissal from their posts of all candidates. Its objective was to secure chits from Turkey. However, the Nazis’ disinformation on the “Turkish project” implied that it was part of “Kultur propaganda abroad.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn22",
      "id": "rintfn22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following the precedent set by Sultan Bayazid II in 1492,"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn23",
      "id": "rintfn23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" and which became again a matter of government policy from 1933 through WWII, Turkey extended invitations to those it selected. It provided safe-haven to intellectuals and professionals fleeing Austria, Germany, Czechoslovakia, and France. All could bring their immediate families; many were even allowed to bring assistants and their families. Even if some could have received a US or UK visa, they chose the certainty of having an academic position within their expertise in Turkey against the possibility of being unemployed or underemployed in the West. Rudolf Nissen, a surgeon, switched his itinerary while en route to the US upon receipt of a telegram with a job offer in Turkey. Albert Einstein, on the other hand, was allegedly taking the Turkish option until a job offer from the Princeton Institute came at the last minute."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn24",
      "id": "rintfn24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Altogether, approximately 300 academicians and 50 technicians and supporting staff went to Turkey. Including family members, this meant more than 1000 persons."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn25",
      "id": "rintfn25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Most thrived in Turkey. Most were given university positions as Ordinarius"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn26",
      "id": "rintfn26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" professors and as professors both in Istanbul and Ankara."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn27",
      "id": "rintfn27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Some received appointments at the Academy of Fine "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("Arts. These refugees included leading professors, research scientists, physicians, dentists, attorneys, architects, urban planners, engineers, artists, librarians, conservationists, and laboratory workers as well as hundreds of lesser-status professionals."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn28",
      "id": "rintfn28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" At the outset, Turkey’s government attempted to give the émigrés every possible facility to carry out their work. Great sums were spent on equipment for laboratories and for hospitals. Appropriations were made for operating the physical plants."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn29",
      "id": "rintfn29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The impact of these émigré professors"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn30",
      "id": "rintfn30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" is immeasurable. They totally transformed Turkey’s higher education in the sciences, professions, humanities, and the arts. They also re-engineered its public health, library, legal, engineering, and administrative practices. The multi-faceted legacy to present Turkish society is everywhere. However, many counteractive forces were in place and active.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Turkey was teeming with Nazi sympathizers and nationalists. Because of Turkey’s neutrality, some of the émigrés were actually able to leave during the course of the war. Some secured good positions at American universities. Such was the case with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard von Mises")]), _vm._v(" joining Harvard and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Arthur von Hippel,")]), _vm._v(" MIT. In the years following the war’s end and having accomplished their mandate, most of the other émigrés came to the United States. They made major contributions to American science, engineering, and culture. The Albert Einstein archives yield one indication of the caliber of the people involved: Einstein maintained a personal correspondence with at least sixteen of the émigrés to Turkey."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn31",
      "id": "rintfn31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It should be noted that during the period starting with the Nazis gaining formal power on January 30 1933 and Germany’s surrender on May 8 1945, the Republic of Turkey had two presidents. Kemal Atatürk served until his death November 10 1938. He was immediately succeeded by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ismet Inönü")]), _vm._v(" who served in that capacity until May 22 1950. Additionally, this period spanned over four prime ministers, five foreign ministers, six interior ministers, and five education ministers. Obviously, the policy of providing safe haven to these intellectuals was not dependent on the largesse of any one individual. It was indeed institutionalized. But at various points in time in this period, neutral Turkey was under relentless pressure by the German Reich (as high up as Hitler himself) that the Jewish professors"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn32",
      "id": "rintfn32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" “be returned to Germany for punishment along with all Jewish Turks.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn33",
      "id": "rintfn33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not to be overlooked or underestimated is the fact that Turkey was still healing its wounds from World War I—a war in which it was soundly defeated. Its economic, industrial, transportation, and agricultural infrastructures were destroyed. The war’s trauma and the poverty, hunger, and epidemics that followed took their toll. Of its 25 million population, close to two million, died in that war. Also, three sides of Turkey’s borders "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("abutted the vast Muslim world. Its own population predominantly Muslim, Turkey had a natural affinity for its neighbors. Some of these neighbors, however, harbored large and overtly pro-Nazi elements. In Turkey itself, factions opposing the government and its policies made political capital of the difficult memories. They did this preying on fears, real and imagined, to keep Turkey from getting entangled in yet another war. Other motives for other groups abounded. Germany’s Nazis and their in-country agents fed the fear that any Turkish policy appearing to contradict their own would be interpreted as a violation of neutrality and a pretext for war. Lastly, Turkey was caught between the Nazi hammer and the Soviet anvil at a time when the West was ambivalent to the plight of Europe’s Jews."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn34",
      "id": "rintfn34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In retrospect, no other nation had the kind of bold policies to compare with Turkey’s explicit plan to invite, save, and allow to flourish and conserve for future generations so much intellectual capital during the darkest years of the twentieth century. The consequences of that brave decision are like the ripples from a pebble tossed into still water. However, these have gained a momentum of their own. They can be seen worldwide to this very day and will be seen in perpetuity. Yet this bit of history is dimly lit"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn35",
      "id": "rintfn35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" and largely unknown. Therefore, this book has been written to see that the future generations “do not live alienated from their ancestry and in ignorance of the events that have given shape to their present.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn36",
      "id": "rintfn36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately, Atatürk’s death came much too early for all concerned, especially Turkey itself. A number of his visionary programs were not fully developed by his successors. Some were curtailed for economic reasons; some were allowed to be sabotaged by petty functionaries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his memoir, Fritz Neumark, one of the émigré economists, observed that “although in the years following 1933 the number of Germanspeaking refugees in other countries, especially in the United States, far exceeded those in Turkey, in no other place was the relative significance of German refugees as great as it was in Turkey, and nowhere else did their work leave as permanent an impact.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn37",
      "id": "rintfn37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" On the other hand, “the image of Turkey in present-day Germany is determined by the so called ’Gastarbeiter,’ literally guest workers, but actually foreign laborers, and “mainly negative,” while in Turkey “Germany is regarded as a country in which people who, for political and religious reasons are being persecuted.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn38",
      "id": "rintfn38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentl"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Turkish hospitality")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The tradition of Turkish hospitality—especially to the persecuted—is not widely known in the Eurocentric West. Arguably, the first to avail themselves of refuge in Turkish lands were Jews persecuted in Christian "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Europe. The first recorded migrations to Ottoman Turkey were in 1376 from Hungary and 1394 from France when they were expelled by Charles VI. Later, after Sultan Mehmet the Conqueror took Constantinople and the Jews there experienced life under Turkish rule, Rabbi Isaac Zarfati wrote to his co-religionists in Europe calling on them to escape Christian persecution by coming to live in the domain of the Sultans. The largest number came in 1492. These were Jews who had lived in Spain for centuries under Moslem rule but were expelled by King Ferdinand as part of the Spanish Inquisition. The Russian Revolution of 1917 sent a flood of refugees to Turkey. And Turkey, although still at war, took in these refugees even though they came from countries that formerly had been enemies. In 1929, Leon Trotsky, the Soviet revolutionary who had a falling out with Stalin, himself was granted refuge on one of the Princes’ Islands before departing for Mexico where he was assassinated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In summation, Turkey’s educational reforms were served well by her invitations to Nazi-persecuted intelligentsia. Development of the country’s universities likewise enhanced Atatürk’s vision of modernizing and westernizing Turkish society. The results were astounding and are felt to this very day. Albeit unintended, the preservation of so much intellectual capital for current and future generations was a gift beyond measure to the world at large.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By comparison, the United States and Europe failed in their duties or promises to promote liberty and preserve lives. “All attempts to liberalize the US quota system of immigration failed, even during the emergencies of the war and the Holocaust period. Many [German and Austrian scholars] could have been saved if the U.S. government and public had understood the seriousness of the Jewish plight of the Holocaust period, and had acted on that understanding.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn39",
      "id": "rintfn39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here is the text of a remarkably important letter from Robert Skinner, American Ambassador, Istanbul, on November 10 1933, sent to the American Secretary of State, Cordell Hull, winner of the Nobel Peace Prize in 1945 ("), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_5"
    }
  }, [_vm._v("Fig. 5")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Introduction#fig_6"
    }
  }, [_vm._v("6")]), _vm._v(")"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn40",
      "id": "rintfn40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sir:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The far-reaching effect of the expulsion from Germany under the Hitler regime cannot be actually measured as yet, but it may take on the importance of the expulsion of the Huguenots from France several centuries ago, and at all events, is likely to turn out advantageously for countries like Turkey which are endeavoring to make intellectual progress along western lines. According to my information, 35 newly employed foreign professors have been "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("taken into the University of Istanbul, of whom 30 are understood to have arrived and all of whom, with the exception of one Austrian and one Swiss, are German Jews who were either expelled or who left Germany on account of the recent political troubles. All of these professors were recommended to Professor Malche, who is at the head of the university reform movement here, by a certain Professor Schwarz, the Secretary of an organization with its seat in Zurich, and which endeavors to find employment for German intellectuals who were obliged to leave that country for political and racial reasons. Professor Schwarz, himself now figures among the professors employed by the Istanbul University.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At Ankara two German Jews have been employed recently, one a professor of chemistry in the Ministry of Agriculture, who is now teaching in one of the Institutes of Agriculture which opened during recent national festivities. One is a photographer employed by the Department of Museums under the Ministry of Public Instruction. There are also four German doctors of medicine, engaged to work with the Ministry of Public Hygiene in the newly inaugurated hospital at Ankara, whose duties according to the contracts, begin in the hospital at the end of the year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Respectfully yours,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Robert P. Skinner")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("American Ambassador.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This letter speaks for itself. However, it was followed on the very same day with, “In regard to the difficulties of the Jews in Germany and the engagement of German Jewish professors in this country, I now enclose as of possible interest in this connection a list of the names of foreign professors appointed to the University of Istanbul, all of them, I imagine being of the Jewish race, as indeed the names themselves sufficiently indicate.”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn41",
      "id": "rintfn41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("German-speaking Europe’s Age of Enlightenment dwindled into the darkness of war. The world suffered the loss of its own humanistic ideals, and there came in the darkness an age unparalleled in its barbarisms."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Notes#intfn42",
      "id": "rintfn42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" The German-Jewish symbiosis which has spawned such irrevocably monumental cultural and scientific achievements, came to a crashing and irreparable end.")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("I cannot understand the passive response of the whole civilized world to this modern barbarism. Doesn’t the world see that Hitler is aiming for war?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("—Albert Einstein, October 1, 1933; quoted by a reporter for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bunte Welt")]), _vm._v(" (Vienna) in Pais, Einstein Lived Here, p. 194.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 2")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("May 10. berlin Book burning.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0014-02.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 3")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Beyazit Portal to Istanbul University, circa 1933.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0015-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 4")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Dr. Philipp Schwarz")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0016-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 5")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Letter to the U.S. Secretary of State from American Ambassador in Istanbul, on November 10, 1933.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "fig_6"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0017-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Figure 6")])]), _vm._v(" "), _c('p', {
    staticClass: "cap1"
  }, [_vm._v("Letter continued"), _c('a', {
    attrs: {
      "id": "page_18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d5d55de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/08_Introduction.vue
// module id = 90
// module chunks = 0